import React from "react";
import { Stack, Divider } from "@mui/material";

import { formatDate } from "../../utils";

const ANCShow = ({ ANCData }) => {
  return (
    <Stack
      spacing={4}
      divider={
        <Divider
          sx={{
            borderColor: "#b0bec5",
            borderBottomWidth: 2,
            marginY: 2,
          }}
          orientation="horizontal"
        />
      }
    >
      <Stack spacing={2}>
        <h3>Patient Data</h3>
        <p>
          <strong>Patient ID:</strong> {ANCData.patient_id}
        </p>
        <p>
          <strong>Creation Date:</strong> {formatDate(ANCData.creation_date)}
        </p>
      </Stack>
      {Object.keys(ANCData)
        .filter((key) => !["id", "patient_id", "creation_date"].includes(key)) // Exclude metadata keys
        .map((sectionKey) => {
          const sectionData = JSON.parse(ANCData[sectionKey]); // Parse JSON string for each section
          return (
            <Stack key={sectionKey} spacing={2}>
              <h3>{sectionData.label}</h3>
              {Object.keys(sectionData)
                .filter((questionKey) => questionKey !== "label")
                .map((questionKey) => (
                  <p key={questionKey}>
                    <strong>
                      {questionKey} : {sectionData[questionKey]}
                    </strong>
                  </p>
                ))}
            </Stack>
          );
        })}
    </Stack>
  );
};

export default ANCShow;
